import { FormSelectDataType } from '@systemeio/ui'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { CourseBundleAccessType } from '../../types/course-bundle-interface'
import {
  AccessTypeEnum,
  AccessTypeCaptions,
} from '../../../courses/curriculum/enums/access-type-enum'

export function getCourseBundleAccessTypeDataOptions(
  t: TLocoType,
): FormSelectDataType<CourseBundleAccessType>[] {
  return [
    { id: AccessTypeEnum.fullAccess, caption: t(AccessTypeCaptions[AccessTypeEnum.fullAccess]) },
    {
      id: AccessTypeEnum.drippingContent,
      caption: t(AccessTypeCaptions[AccessTypeEnum.drippingContent]),
    },
  ]
}
